import ImageTool from './tools/image';

export default {
    image: new ImageTool(),
};
